import { AuthGuardService } from '@sc/pas-common';
import { EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainSideBarService } from './main-side-bar.service';
import { ModalService } from 'app/components/shared/modal/modal.service';
import { HomeUrlHelper } from '@sc/pas-common';
import { Observable } from 'rxjs';
import { NotificationService } from '../notification/notification.service';
import { FeatureToggleService } from '@sc/pas-common';
var MainSideBarComponent = /** @class */ (function () {
    function MainSideBarComponent(router, urlHelper, authService, mainSideBarService, modalService, notificationService, featureToggleService) {
        var _this = this;
        this.router = router;
        this.urlHelper = urlHelper;
        this.authService = authService;
        this.mainSideBarService = mainSideBarService;
        this.modalService = modalService;
        this.notificationService = notificationService;
        this.featureToggleService = featureToggleService;
        this.blocking = false;
        this.state = 'closed';
        this.hideSideBarMenu = false;
        this.onGoTo = new EventEmitter();
        this.maxLabelLength = 25;
        this.onHandleNotificationBellClick = new EventEmitter();
        this.loadData();
        this.pages = [{
                route: 'inicio',
                embedded: true,
                label: 'Inicio'
            }];
        this.isModalErrorShowing = false;
        this.isRouteLoading = false;
        this.mainSideBarService.reloadMenu.subscribe(function (newSelectedRoute) {
            var renewFeatures = true;
            _this.loadData(renewFeatures, newSelectedRoute);
        });
    }
    Object.defineProperty(MainSideBarComponent.prototype, "hasUnseenNotifications", {
        get: function () {
            return this.notificationService.unseenNotificationsCount > 0;
        },
        enumerable: true,
        configurable: true
    });
    MainSideBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.noShowHeader = this.router.url === '/faq' || this.router.url === '/login' || this.router.url.includes('login');
        this.user = JSON.parse(localStorage.getItem('userInfo'));
        this.onMessage().subscribe(function (message) {
            if (message.loadSubItemFromMenu !== undefined) {
                _this.loadSubItemFromMenu(message.loadSubItemFromMenu);
            }
        });
        this.getUnseenNotificationsCount();
    };
    MainSideBarComponent.prototype.getUnseenNotificationsCount = function () {
        this.notificationService.getUnseenNotificationsCount();
    };
    MainSideBarComponent.prototype.loadSubItemFromMenu = function (subItemText) {
        var _this = this;
        var indexItem = 0;
        this.sideBarItems.forEach(function (item) {
            if (item.items) {
                var indexSubItem_1 = 0;
                item.items.forEach(function (subItem) {
                    if (subItem.text === subItemText) {
                        item.selected = true;
                        _this.goTo(subItem, 0, indexItem, indexSubItem_1);
                    }
                    indexSubItem_1++;
                });
            }
            indexItem++;
        });
    };
    MainSideBarComponent.prototype.loadData = function (renewFeatures, selectedItemRoute) {
        var _this = this;
        this.featureToggleService.getFeaturesByUsername(this.authService.user.userName, renewFeatures).subscribe(function () {
            _this.mainSideBarService.getData().subscribe(function (data) {
                _this.sbData = data;
                _this.sideBarItems = data && data['side-bar'];
                _this.profileItems = data && data['profile'];
                _this.downloadsItems = data && data['downloads'];
                _this.selectItemInMenuByRoute(selectedItemRoute);
            });
        });
    };
    MainSideBarComponent.prototype.selectItemInMenuByRoute = function (selectedItemRoute) {
        if (selectedItemRoute) {
            var subItem = this.sideBarItems.find(function (sideBarItem) { return sideBarItem.items && sideBarItem.items.find(function (item) { return item.route == selectedItemRoute; }); });
            if (subItem) {
                subItem.selected = true;
                subItem.items.find(function (item) { return item.route == selectedItemRoute; }).selected = true;
            }
            else {
                var item = this.sideBarItems.find(function (mainItem) { return mainItem.route == selectedItemRoute; });
                if (item) {
                    item.selected = true;
                }
            }
        }
    };
    MainSideBarComponent.prototype.toggleMenu = function () {
        this.menuOpened = !this.menuOpened;
        this.downloadOpened = false;
        this.profileOpened = false;
    };
    MainSideBarComponent.prototype.closeMenu = function () {
        this.menuOpened = false;
        this.downloadOpened = false;
        this.profileOpened = false;
    };
    MainSideBarComponent.prototype.toggleProfile = function (back, forward) {
        if (back === void 0) { back = false; }
        if (forward === void 0) { forward = false; }
        if (!back && !forward) {
            this.downloadOpened = false;
            this.menuOpened = false;
        }
        this.profileOpened = !this.profileOpened;
        this.closeNotification();
    };
    MainSideBarComponent.prototype.toggleDownload = function (back, forward) {
        if (back === void 0) { back = false; }
        if (forward === void 0) { forward = false; }
        if (!back && !forward) {
            this.profileOpened = false;
            this.menuOpened = false;
        }
        this.downloadOpened = !this.downloadOpened;
        this.closeNotification();
    };
    MainSideBarComponent.prototype.resetSelected = function (selectedItem, selectedSubItem) {
        if (selectedItem === void 0) { selectedItem = undefined; }
        if (selectedSubItem === void 0) { selectedSubItem = undefined; }
        this.unSelect(this.sideBarItems, selectedItem, selectedSubItem);
        this.unSelect(this.downloadsItems, selectedItem, selectedSubItem);
        this.unSelect(this.profileItems, selectedItem, selectedSubItem);
    };
    MainSideBarComponent.prototype.unSelect = function (items, selectedItem, selectedSubItem) {
        if (selectedItem === void 0) { selectedItem = undefined; }
        if (selectedSubItem === void 0) { selectedSubItem = undefined; }
        items.forEach(function (item, itemIndex) {
            // We need to unselect the item when
            // (a) the current selected is an item (not a subitem)
            // (b) the current selected is a subitem and the parent item is not selected
            var isUnselectRequired = !!(typeof selectedSubItem === 'undefined' ||
                (typeof selectedSubItem !== 'undefined' && selectedItem !== itemIndex));
            if (isUnselectRequired) {
                item.selected = false;
            }
            // If this item has subitems then unselect all subitems
            if (item.items) {
                item.items.forEach(function (si) { return si.selected = false; });
            }
        });
    };
    MainSideBarComponent.prototype.goTo = function (item, i0, i1, i2) {
        this.resetSelected(i1, i2);
        if (this.isNavigationAvailable(item)) {
            this.closeMenu();
            // Save info about where I want to navigate
            this.navigateTo = { item: item, i0: i0, i1: i1, i2: i2 };
            // Set this item as selected
            item.selected = true;
            // If this route doesn't need authorization
            // then navigation is authorized
            if (!item.isAuthenticationNeeded) {
                this.navigate(item, i0, i1, i2);
                return;
            }
            this.isRouteLoading = true;
            this.navigate(item, i0, i1, i2);
        }
        else {
            item.selected = !item.selected;
        }
    };
    MainSideBarComponent.prototype.navigate = function (item, i0, i1, i2) {
        if (!item && !i0 && !i1 && !i2) {
            item = this.navigateTo.item;
            i0 = this.navigateTo.i0;
            i1 = this.navigateTo.i1;
            i2 = this.navigateTo.i2;
        }
        this.modalService.close('authModal');
        var index = { sb: this.urlHelper.setJSONIndex(i0, i1, i2) };
        this.onGoTo.emit({ item: item, index: index });
    };
    MainSideBarComponent.prototype.isNavigationAvailable = function (item) {
        return !!item.link;
    };
    MainSideBarComponent.prototype.openAuthorizationModal = function () {
        this.authorizePassword = null;
        this.isModalErrorShowing = false;
        this.modalConfig = {
            closeButton: true,
            size: 'small',
            buttons: []
        };
        this.modalService.open('authModal');
    };
    MainSideBarComponent.prototype.openFaq = function () {
        this.closeNotification();
        var url = this.urlHelper.getUrlSoportePas();
        window.open(url, '_blank');
    };
    MainSideBarComponent.prototype.logOut = function () {
        this.downloadOpened = false;
        this.profileOpened = false;
        this.menuOpened = false;
        this.authService.logOut();
    };
    MainSideBarComponent.prototype.onMessage = function () {
        return new Observable(function (observer) {
            window.addEventListener('message', function (event) {
                if (typeof (event.data) !== 'undefined') {
                    observer.next(event.data);
                }
            });
        });
    };
    MainSideBarComponent.prototype.isStandAlone = function () {
        return this.router.url.indexOf('cotizador-integral-comercio') > -1;
    };
    MainSideBarComponent.prototype.closeNotification = function () {
        if (this.isNotificationOpened) {
            this.isNotificationOpened = !this.isNotificationOpened;
            this.onHandleNotificationBellClick.emit(this.isNotificationOpened);
        }
    };
    MainSideBarComponent.prototype.notificationBellClick = function () {
        this.isNotificationOpened = !this.isNotificationOpened;
        this.onHandleNotificationBellClick.emit(this.isNotificationOpened);
    };
    return MainSideBarComponent;
}());
export { MainSideBarComponent };
